import React from 'react';
import { Alert, Button } from '@mui/material';
import useOrderCheckRetry from '../../hooks/useOrderCheckRetry.hooks';

/**
 * Warning banner with a Retry action, shown when the latest order has gone
 * unconfirmed — no check event within the configured timeout (see
 * useOrderCheckRetry). Clicking Retry resends the current order so the agent
 * no longer has to add/remove a throwaway item to force one.
 */
export default function OrderCheckRetryAlert({
  isUnifiedMenu,
  menuUnificationOrderFailureCallback,
  menuUnificationOrderSuccessCallback,
}: {
  isUnifiedMenu: boolean;
  menuUnificationOrderFailureCallback: Function;
  menuUnificationOrderSuccessCallback: Function;
}) {
  const { isCheckOverdue, isRetrying, retry } = useOrderCheckRetry({
    isUnifiedMenu,
    menuUnificationOrderFailureCallback,
    menuUnificationOrderSuccessCallback,
  });

  if (!isCheckOverdue) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      sx={{ marginBottom: '8px' }}
      action={
        // Disabled while a resend is in flight — a second click would send a
        // duplicate order whose check would supersede (and discard) the
        // first's. Re-enabled when the resend lands as a new latest request;
        // on the legacy (non-menu-module) path that happens synchronously, so
        // the disable is only observable on the menu-module HTTP round trip.
        <Button
          color="inherit"
          size="small"
          onClick={retry}
          disabled={isRetrying}
        >
          Retry
        </Button>
      }
    >
      The POS hasn't confirmed the order — click Retry to resend it
    </Alert>
  );
}
